/**
 * EROS PRJCT — Custom Features JS v6.0 (+ CartUpsells)
 * Modules: Quick Add, Cart open, Hero Curtain reveal, Big Logo morph,
 * Parallax Worlds, Scroll Stack, Sticky Hero, Size Advisor.
 * Re-runs on Shopify theme-editor events.
 */

(function () {
  'use strict';

  var cache = {};
  var IS_TOUCH = matchMedia('(hover: none), (pointer: coarse)').matches
                 || window.innerWidth < 750;

  function fetchProduct(handle, cb) {
    if (cache[handle]) { cb(cache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (p) { cache[handle] = p; cb(p); })
      .catch(function () { cb(null); });
  }

  function findCartSectionIds() {
    var ids = new Set();
    document.querySelectorAll(
      'cart-drawer-component, cart-icon-component, cart-bubble, [data-cart-count], cart-count-bubble-component'
    ).forEach(function (el) {
      var sec = el.closest('[id^="shopify-section-"]');
      if (sec) ids.add(sec.id.replace('shopify-section-', ''));
    });
    return Array.from(ids);
  }

  function replaceMatchingElement(newDoc, selector, root) {
    var incoming = newDoc.querySelector(selector);
    var current  = (root || document).querySelector(selector);
    if (incoming && current) { current.replaceWith(incoming); return true; }
    return false;
  }

  function rerenderCartRegions(sectionsData) {
    if (!sectionsData) return;
    var parser = new DOMParser();
    Object.keys(sectionsData).forEach(function (secId) {
      var html = sectionsData[secId]; if (!html) return;
      var doc = parser.parseFromString(html, 'text/html');
      ['cart-drawer-component','cart-items-component','cart-bubble','cart-icon-component','cart-count-bubble-component']
        .forEach(function (sel) { replaceMatchingElement(doc, sel); });
    });
  }

  function refreshCartCounts(cart) {
    var count = cart ? cart.item_count : null; if (count == null) return;
    document.querySelectorAll(
      '[data-cart-count], .cart-count-bubble span, .cart-count, cart-bubble [data-count]'
    ).forEach(function (el) { el.textContent = String(count); });
    var drawer = document.querySelector('cart-drawer-component .cart-drawer__dialog');
    if (drawer) drawer.classList.toggle('cart-drawer--empty', count === 0);
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    var btn = document.querySelector('cart-drawer-component button[aria-label*="cart" i]')
           || document.querySelector('cart-drawer-component button');
    if (btn) { btn.click(); return true; }
    return false;
  }

  function addToCart(variantId, onDone, onFail) {
    var sectionIds = findCartSectionIds();
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionIds.length) body.sections = sectionIds.join(',');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('add-to-cart failed'); return r.json(); })
      .then(function (resp) {
        if (resp && resp.sections) rerenderCartRegions(resp.sections);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartCounts(cart);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
        openCartDrawer();
        onDone && onDone();
      })
      .catch(function (err) { console.warn('[eros] add-to-cart error', err); onFail && onFail(); });
  }

  function getSizes(product) {
    var sizeIdx = -1;
    product.options.forEach(function (o, i) {
      var name = typeof o === 'string' ? o : (o.name || '');
      if (name.toLowerCase() === 'size') sizeIdx = i;
    });
    if (sizeIdx < 0 && product.options.length) sizeIdx = 0;
    var seen = {}, opts = [];
    product.variants.forEach(function (v) {
      var label = v.options[sizeIdx] || v.title;
      if (seen[label]) return; seen[label] = true;
      var avail = null, any = null;
      product.variants.forEach(function (vv) {
        var l = vv.options[sizeIdx] || vv.title;
        if (l !== label) return;
        if (!any) any = vv;
        if (!avail && vv.available) avail = vv;
      });
      opts.push({ label: label, id: avail ? avail.id : (any ? any.id : null), available: !!avail });
    });
    return opts;
  }

  function isSingle(product) {
    return product.variants.length === 1 && product.variants[0].title === 'Default Title';
  }

  function fillBar(bar, product) {
    bar.innerHTML = '';
    if (isSingle(product)) return;
    getSizes(product).forEach(function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'eqa-size' + (!opt.available ? ' is-oos' : '');
      b.textContent = opt.label;
      b.disabled = !opt.available;
      if (opt.id) b.dataset.variantId = String(opt.id);
      bar.appendChild(b);
    });
  }

  function injectPlusButton(card, handle) {
    var gallery = card.querySelector('.card-gallery');
    if (!gallery) return;
    if (gallery.querySelector('.eqa-plus')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'eqa-plus';
    btn.setAttribute('aria-label', 'Quick add');
    btn.dataset.handle = handle;
    btn.innerHTML =
      '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
      '<line x1="8" y1="3" x2="8" y2="13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '<line x1="3" y1="8" x2="13" y2="8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '</svg>';
    gallery.appendChild(btn);
  }

  function setupCard(card) {
    if (card.querySelector('.eros-soldout-overlay')) return;
    var handle = card.dataset.productHandle;
    if (!handle) return;
    var content = card.querySelector('.product-card__content');
    var gallery = content && content.querySelector('.card-gallery');
    if (!content || !gallery) return;
    injectPlusButton(card, handle);
  }

  /**
   * ViewToggle — segmented pill with two states: MODEL (default) and PRODUCT.
   * First slide of every product gallery is the MODEL image, second slide is
   * the flat product / detail shot. Default view shows the model (pill left).
   * Unchecked = model, checked = product.
   */
  var ViewToggle = {
    mode: 'model',
    init: function () {
      var self = this;
      try { var s = sessionStorage.getItem('eros_view_mode'); if (s === 'model' || s === 'product') self.mode = s; } catch (e) {}
      var inputs = document.querySelectorAll('.eros-toggle-input[data-view-toggle]');
      inputs.forEach(function (inp) { inp.checked = self.mode === 'product'; });
      self.apply(self.mode);
      inputs.forEach(function (inp) {
        inp.addEventListener('change', function () {
          self.mode = inp.checked ? 'product' : 'model';
          document.querySelectorAll('.eros-toggle-input[data-view-toggle]').forEach(function (o) {
            if (o !== inp) o.checked = inp.checked;
          });
          self.apply(self.mode);
          try { sessionStorage.setItem('eros_view_mode', self.mode); } catch (e) {}
        });
      });
    },
    apply: function (mode) {
      document.querySelectorAll('.card-gallery').forEach(function (g) {
        var ss = g.querySelectorAll('slideshow-slide'); if (ss.length < 2) return;
        if (mode === 'product') {
          // Show second slide (flat product shot), hide everything else.
          ss[0].setAttribute('hidden', ''); ss[0].setAttribute('aria-hidden', 'true');
          ss[1].removeAttribute('hidden'); ss[1].setAttribute('aria-hidden', 'false');
          for (var i = 2; i < ss.length; i++) { ss[i].setAttribute('hidden', ''); ss[i].setAttribute('aria-hidden', 'true'); }
        } else {
          // model (default) — show first slide only.
          ss[0].removeAttribute('hidden'); ss[0].setAttribute('aria-hidden', 'false');
          for (var j = 1; j < ss.length; j++) { ss[j].setAttribute('hidden', ''); ss[j].setAttribute('aria-hidden', 'true'); }
        }
      });
    }
  };

  var QuickAdd = {
    sheet: null, sheetSizes: null, sheetFeedback: null, backdrop: null, inited: false,
    init: function () {
      if (!this.inited) { this.buildSheet(); this.bindClicks(); this.inited = true; }
      this.injectAll();
      var self = this;
      // Re-inject when new product-cards are added (recommendations load async)
      try {
        var mo = new MutationObserver(function (mutations) {
          var hasNewCard = false;
          mutations.forEach(function (m) {
            for (var i = 0; i < m.addedNodes.length; i++) {
              var n = m.addedNodes[i];
              if (n.nodeType !== 1) continue;
              if (n.tagName === 'PRODUCT-CARD' || (n.querySelector && n.querySelector('product-card'))) {
                hasNewCard = true; break;
              }
            }
          });
          if (hasNewCard) self.injectAll();
        });
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
      // Also re-inject on Shopify section reloads
      document.addEventListener('shopify:section:load', function () { self.injectAll(); });
    },
    injectAll: function () { document.querySelectorAll('product-card').forEach(function (c) { setupCard(c); }); },
    bindClicks: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.eqa-size');
        if (!btn || btn.disabled || btn.classList.contains('is-oos')) return;
        var id = parseInt(btn.dataset.variantId, 10); if (!id) return;
        e.preventDefault(); e.stopPropagation();
        var bar = btn.closest('.eqa-sizes-bar');
        if (bar) bar.querySelectorAll('.eqa-size').forEach(function (b) { b.style.opacity = '0.4'; b.disabled = true; });
        addToCart(id,
          function () { if (bar) bar.querySelectorAll('.eqa-size').forEach(function (b) { b.style.opacity = ''; b.disabled = b.classList.contains('is-oos'); }); },
          function () { if (bar) bar.querySelectorAll('.eqa-size').forEach(function (b) { b.style.opacity = ''; b.disabled = b.classList.contains('is-oos'); }); }
        );
      });
      document.addEventListener('click', function (e) {
        var plus = e.target.closest('.eqa-plus');
        if (!plus) return;
        e.preventDefault(); e.stopPropagation();
        self.openSheet(plus.dataset.handle);
      });
    },
    buildSheet: function () {
      var self = this;
      /* Use native <dialog> so this sheet joins the top-layer stack ABOVE
         the cart drawer (which is also a <dialog>). Newest top-layer wins. */
      this.sheet = document.createElement('dialog');
      this.sheet.className = 'eqa-sheet';
      this.sheet.innerHTML = '<div class="eqa-sheet__handle"></div><div class="eqa-sheet__sizes"></div><div class="eqa-sheet__feedback" hidden></div>';
      document.body.appendChild(this.sheet);
      this.sheetSizes = this.sheet.querySelector('.eqa-sheet__sizes');
      this.sheetFeedback = this.sheet.querySelector('.eqa-sheet__feedback');
      /* Tap on ::backdrop area closes */
      this.sheet.addEventListener('click', function (e) {
        if (e.target === self.sheet) self.close();
      });
      this.sheet.querySelector('.eqa-sheet__handle').addEventListener('click', function () { self.close(); });
      /* Native dialog already handles Escape; still guard */
      this.sheet.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
      var y0 = 0;
      this.sheet.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
      this.sheet.addEventListener('touchend', function (e) { if (e.changedTouches[0].clientY - y0 > 60) self.close(); }, { passive: true });
    },
    openSheet: function (handle) {
      var self = this;
      this.sheetSizes.innerHTML = '<span style="display:block;text-align:center;padding:18px;opacity:0.3;font-size:13px;font-family:inherit">—</span>';
      this.sheetFeedback.hidden = true; this.sheetSizes.hidden = false;
      if (typeof this.sheet.showModal === 'function' && !this.sheet.open) {
        try { this.sheet.showModal(); } catch (e) { this.sheet.setAttribute('open', ''); }
      } else {
        this.sheet.setAttribute('open', '');
      }
      this.sheet.classList.add('is-open');
      fetchProduct(handle, function (product) {
        if (!product) { self.sheetSizes.innerHTML = '<span style="display:block;text-align:center;padding:18px;opacity:0.3;font-size:13px;font-family:inherit">could not load</span>'; return; }
        if (isSingle(product)) {
          addToCart(product.variants[0].id, function () { self.done('added'); }, function () { self.done('something went wrong.'); });
          return;
        }
        self.sheetSizes.innerHTML = '';
        getSizes(product).forEach(function (opt) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'eqa-sheet__size' + (!opt.available ? ' is-oos' : '');
          b.textContent = opt.label;
          b.disabled = !opt.available;
          if (opt.available && opt.id) {
            ;(function (vid) {
              b.addEventListener('click', function () {
                self.sheetSizes.querySelectorAll('.eqa-sheet__size').forEach(function (x) { x.disabled = true; });
                addToCart(vid, function () { self.done('added'); }, function () {
                  self.sheetSizes.querySelectorAll('.eqa-sheet__size:not(.is-oos)').forEach(function (x) { x.disabled = false; });
                });
              });
            }(opt.id));
          }
          self.sheetSizes.appendChild(b);
        });
      });
    },
    done: function (msg) { var self = this; this.sheetFeedback.textContent = msg; this.sheetFeedback.hidden = false; this.sheetSizes.hidden = true; setTimeout(function () { self.close(); }, 500); },
    close: function () {
      var self = this;
      this.sheet.classList.remove('is-open');
      if (typeof this.sheet.close === 'function' && this.sheet.open) {
        try { this.sheet.close(); } catch (e) { this.sheet.removeAttribute('open'); }
      } else {
        this.sheet.removeAttribute('open');
      }
      setTimeout(function () { self.sheetSizes.hidden = false; self.sheetFeedback.hidden = true; self.sheetSizes.innerHTML = ''; }, 320);
    }
  };

  function setupCurtainReveal() {
    document.querySelectorAll('.eros-curtain-host, .eros-curtain-revealer').forEach(function (el) {
      el.classList.remove('eros-curtain-host');
      el.classList.remove('eros-curtain-revealer');
    });
    document.querySelectorAll('.eros-curtain-v2--sticky').forEach(function (el) {
      var section = el.closest('.shopify-section'); if (!section) return;
      section.classList.add('eros-curtain-host');
      var next = section.nextElementSibling;
      while (next && !next.classList.contains('shopify-section')) next = next.nextElementSibling;
      if (next && next.classList.contains('shopify-section')) next.classList.add('eros-curtain-revealer');
    });
  }

  var BigLogo = {
    scrollBound: false, rafTicking: false,
    init: function () {
      var el = document.querySelector('.eros-big-logo');
      if (el) document.body.classList.add('eros-big-logo-active');
      else    document.body.classList.remove('eros-big-logo-active', 'has-big-logo-big');
      if (!el) return;
      var self = this;
      if (!self.scrollBound) {
        self.scrollBound = true;
        var onScroll = function () {
          if (self.rafTicking) return;
          self.rafTicking = true;
          requestAnimationFrame(function () { self.apply(); self.rafTicking = false; });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      }
      self.apply();
    },
    apply: function () {
      var el = document.querySelector('.eros-big-logo');
      if (!el) { document.body.classList.remove('has-big-logo-big'); return; }
      var threshold = parseInt(el.dataset.threshold || '40', 10);
      var shrunk = window.scrollY > threshold;
      el.classList.toggle('is-shrunk', shrunk);
      document.body.classList.toggle('has-big-logo-big', !shrunk);
    }
  };

  var ParallaxWorlds = {
    instances: [], scrollBound: false, rafTicking: false,
    init: function () {
      var self = this;
      self.instances = [];
      document.querySelectorAll('.eros-px').forEach(function (root) {
        var sticky = root.querySelector('.eros-px__sticky'); if (!sticky) return;
        var inst = {
          root: root, sticky: sticky,
          navItems: root.querySelectorAll('.eros-px__nav-item'),
          count: parseInt(root.dataset.worldsCount, 10) || 1,
          textParallax: root.dataset.textParallax === 'true',
          currentIndex: -1
        };
        self.instances.push(inst);
        inst.navItems.forEach(function (btn) {
          if (btn.dataset.bound) return;
          btn.dataset.bound = '1';
          btn.addEventListener('click', function () {
            var idx = parseInt(btn.dataset.navIndex, 10);
            var rect = inst.root.getBoundingClientRect();
            var total = rect.height - window.innerHeight;
            if (total <= 0) return;
            var targetProgress = (idx + 0.5) / inst.count;
            var target = window.scrollY + rect.top + targetProgress * total;
            window.scrollTo({ top: target, behavior: 'smooth' });
          });
        });
      });
      if (!self.scrollBound) {
        self.scrollBound = true;
        var handler = function () {
          if (self.rafTicking) return;
          self.rafTicking = true;
          requestAnimationFrame(function () { self.update(); self.rafTicking = false; });
        };
        window.addEventListener('scroll', handler, { passive: true });
        window.addEventListener('resize', handler, { passive: true });
      }
      self.update();
    },
    update: function () {
      var self = this;
      self.instances.forEach(function (inst) {
        var rect = inst.root.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        if (total <= 0) { self.setActive(inst, 0); return; }
        var scrolled = -rect.top;
        var progress = Math.max(0, Math.min(scrolled / total, 1));
        var scaled = progress * inst.count;
        var idx = Math.min(Math.floor(scaled), inst.count - 1);
        var sceneProgress = scaled - idx;
        self.setActive(inst, idx);
        if (inst.textParallax) self.applyTextParallax(inst, sceneProgress);
      });
    },
    setActive: function (inst, index) {
      if (index === inst.currentIndex) return;
      inst.currentIndex = index;
      inst.sticky.setAttribute('data-active-index', String(index));
      inst.navItems.forEach(function (btn) {
        if (parseInt(btn.dataset.navIndex, 10) === index) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    },
    applyTextParallax: function (inst, sceneProgress) {
      var scenes = inst.root.querySelectorAll('.eros-px__scene');
      scenes.forEach(function (scene, i) {
        var text = scene.querySelector('[data-parallax-text]');
        if (!text) return;
        if (i === inst.currentIndex) {
          var y = (0.5 - sceneProgress) * 80;
          text.style.transform = 'translateY(' + y + 'px)';
        } else {
          text.style.transform = '';
        }
      });
    }
  };

  var ScrollStack = {
    instances: [], scrollBound: false, rafTicking: false,

    init: function () {
      var self = this;
      self.instances = [];

      document.querySelectorAll('.eros-ss').forEach(function (root) {
        var slides = Array.prototype.slice.call(root.querySelectorAll('.eros-ss__slide'));
        var menuItems = Array.prototype.slice.call(root.querySelectorAll('.eros-ss__menu-item'));
        var inst = { root: root, slides: slides, menuItems: menuItems, activeIdx: -1 };
        self.instances.push(inst);

        menuItems.forEach(function (item, i) {
          if (item.dataset.bound) return;
          item.dataset.bound = '1';
          item.addEventListener('click', function (e) {
            var isActive = item.classList.contains('is-active');
            if (isActive) {
              var href = item.getAttribute('href');
              if (!href || href === '#') { e.preventDefault(); }
              return;
            }
            e.preventDefault();
            var targetId = item.dataset.target;
            var target = targetId ? document.getElementById(targetId) : null;
            if (target && target.scrollIntoView) {
              target.scrollIntoView({ block: 'center', behavior: 'smooth' });
            } else if (inst.slides[i]) {
              inst.slides[i].scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          });
        });
      });

      if (!self.scrollBound) {
        self.scrollBound = true;
        var onScroll = function () {
          if (self.rafTicking) return;
          self.rafTicking = true;
          requestAnimationFrame(function () {
            self.updateActive();
            self.parallax();
            self.rafTicking = false;
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      }
      self.updateActive();
      self.parallax();
    },

    updateActive: function () {
      var self = this;
      var vpCenter = window.innerHeight / 2;
      self.instances.forEach(function (inst) {
        var sectionRect = inst.root.getBoundingClientRect();
        if (sectionRect.bottom < 0 || sectionRect.top > window.innerHeight) return;
        var bestIdx = -1;
        var bestDist = Infinity;
        inst.slides.forEach(function (slide, i) {
          var r = slide.getBoundingClientRect();
          var slideCenter = r.top + r.height / 2;
          var dist = Math.abs(slideCenter - vpCenter);
          if (dist < bestDist) { bestDist = dist; bestIdx = i; }
        });
        if (bestIdx < 0 || bestIdx === inst.activeIdx) return;
        inst.activeIdx = bestIdx;
        inst.menuItems.forEach(function (it, i) {
          it.classList.toggle('is-active', i === bestIdx);
        });
      });
    },

    parallax: function () {
      var self = this;
      self.instances.forEach(function (inst) {
        inst.slides.forEach(function (slide) {
          var speed = parseFloat(slide.dataset.speed || '0.4');
          var r = slide.getBoundingClientRect();
          var progress = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          var translate = -progress * r.height * speed * 0.5;
          var img = slide.querySelector('.eros-ss__image');
          if (img) img.style.transform = 'translate3d(0,' + translate.toFixed(1) + 'px,0)';
        });
      });
    }
  };

  /* ------------------------------------------------------------ */
  /* STICKY HERO — JS-driven pin via transform                     */
  /* ------------------------------------------------------------ */
  var StickyHero = {
    instances: [], scrollBound: false, rafTicking: false,

    init: function () {
      var self = this;
      self.instances = [];
      document.querySelectorAll('.hero--sticky-content').forEach(function (hero) {
        var content = hero.querySelector('.hero__content-wrapper');
        if (!content) return;
        var anchor = 'top';
        if (hero.classList.contains('hero--sticky-anchor-bottom')) anchor = 'bottom';
        else if (hero.classList.contains('hero--sticky-anchor-center')) anchor = 'center';
        self.instances.push({ hero: hero, content: content, anchor: anchor });
      });
      if (!self.scrollBound) {
        self.scrollBound = true;
        var onScroll = function () {
          if (self.rafTicking) return;
          self.rafTicking = true;
          requestAnimationFrame(function () { self.update(); self.rafTicking = false; });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      }
      self.update();
    },

    update: function () {
      var vh = window.innerHeight;
      this.instances.forEach(function (inst) {
        var hero = inst.hero, content = inst.content;
        var rect = hero.getBoundingClientRect();
        var heroH = hero.offsetHeight, contentH = content.offsetHeight;
        if (heroH <= 0 || contentH <= 0) return;
        var maxTravel = Math.max(0, heroH - contentH);
        var anchorOffset;
        if (inst.anchor === 'bottom') anchorOffset = heroH - contentH;
        else if (inst.anchor === 'center') anchorOffset = (heroH - contentH) / 2;
        else anchorOffset = 0;
        var desiredY;
        if (inst.anchor === 'bottom') desiredY = vh - contentH;
        else if (inst.anchor === 'center') desiredY = (vh - contentH) / 2;
        else desiredY = 0;
        var flowViewportY = rect.top + anchorOffset;
        var rawTranslate = desiredY - flowViewportY;
        var contentTopInHero = anchorOffset + rawTranslate;
        var clampedTopInHero = Math.max(0, Math.min(contentTopInHero, maxTravel));
        var translate = clampedTopInHero - anchorOffset;
        content.style.transform = 'translateY(' + translate + 'px)';
      });
    }
  };

  /* ------------------------------------------------------------ */
  /* SIZE ADVISOR                                                  */
  /* Interactive quiz on PDPs that recommends a size based on      */
  /* height / weight / usual-size / fit preference, driven by a    */
  /* per-product JSON metafield `eros.size_chart`.                 */
  /* ------------------------------------------------------------ */
  var SizeAdvisor = {
    init: function () {
      document.querySelectorAll('.eros-sa:not(.eros-sa--missing)').forEach(function (root) {
        if (root.dataset.saInited) return;
        root.dataset.saInited = '1';
        SizeAdvisor.setup(root);
      });
    },

    setup: function (root) {
      var productId = root.dataset.productId;
      var productHandle = root.dataset.productHandle;
      var productTitle = root.dataset.productTitle || '';
      var chartEl = root.querySelector('[data-sa-chart]');
      var variantsEl = root.querySelector('[data-sa-variants]');
      if (!chartEl || !variantsEl) return;

      var chart, variants;
      try { chart = JSON.parse(chartEl.textContent); } catch (e) { chart = null; }
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
      if (!chart || !chart.sizes || !chart.sizes.length) return;

      var stepOrder = ['intro', 'height', 'weight', 'usual', 'fit', 'result'];
      var state = {
        step: 'intro',
        heightUnit: 'cm', weightUnit: 'kg',
        height_cm: null, height_ft: null, height_in: null,
        weight_kg: null, weight_lb: null,
        usual: null, fit: null,
        result: null
      };

      var modal = root.querySelector('[data-sa-modal]');
      var openBtn = root.querySelector('[data-sa-open]');
      var savedBadge = root.querySelector('[data-sa-saved-badge]');
      var savedKey = 'eros-sa-' + productId;

      /* Restore saved recommendation */
      try {
        var saved = localStorage.getItem(savedKey);
        if (saved) {
          var parsed = JSON.parse(saved);
          if (parsed && parsed.recommended) {
            savedBadge.textContent = '· ' + parsed.recommended;
            savedBadge.setAttribute('data-has-saved', '');
            savedBadge.hidden = false;
          }
        }
      } catch (e) {}

      function showStep(name) {
        state.step = name;
        root.querySelectorAll('[data-sa-step]').forEach(function (el) {
          el.hidden = el.dataset.saStep !== name;
        });
        validateStep();
      }

      function nextStep() {
        var idx = stepOrder.indexOf(state.step);
        if (idx < stepOrder.length - 1) {
          var next = stepOrder[idx + 1];
          if (next === 'result') compute();
          showStep(next);
        }
      }

      function prevStep() {
        var idx = stepOrder.indexOf(state.step);
        if (idx > 0) showStep(stepOrder[idx - 1]);
      }

      function openModal() {
        modal.hidden = false;
        document.body.classList.add('eros-sa-open');
        showStep('intro');
      }

      function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('eros-sa-open');
      }

      openBtn.addEventListener('click', openModal);
      root.querySelectorAll('[data-sa-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });

      root.querySelectorAll('[data-sa-next]').forEach(function (b) { b.addEventListener('click', nextStep); });
      root.querySelectorAll('[data-sa-back]').forEach(function (b) { b.addEventListener('click', prevStep); });

      /* Unit toggles */
      root.querySelectorAll('[data-sa-unit-group]').forEach(function (group) {
        var groupName = group.dataset.saUnitGroup;
        group.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var unit = b.dataset.saUnit;
            group.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
            if (groupName === 'height') state.heightUnit = unit;
            else state.weightUnit = unit;
            var parent = group.parentElement;
            parent.querySelectorAll('[data-sa-unit-view]').forEach(function (v) {
              v.hidden = v.dataset.saUnitView !== unit;
            });
            validateStep();
          });
        });
      });

      /* Numeric inputs */
      root.querySelectorAll('[data-sa-field]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var val = inp.value === '' ? null : Number(inp.value);
          state[inp.dataset.saField] = val;
          validateStep();
        });
      });

      /* Option buttons (usual, fit) */
      root.querySelectorAll('[data-sa-options]').forEach(function (container) {
        var key = container.dataset.saOptions;
        container.querySelectorAll('button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            container.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            state[key] = btn.dataset.saValue;
            validateStep();
          });
        });
      });

      function validateStep() {
        var stepEl = root.querySelector('[data-sa-step="' + state.step + '"]');
        if (!stepEl) return;
        var nextBtn = stepEl.querySelector('[data-sa-next]');
        if (!nextBtn) return;
        var valid = false;
        if (state.step === 'intro') valid = true;
        else if (state.step === 'height') {
          if (state.heightUnit === 'cm') valid = state.height_cm && state.height_cm >= 120 && state.height_cm <= 220;
          else valid = state.height_ft && state.height_ft >= 4 && state.height_ft <= 7;
        } else if (state.step === 'weight') {
          if (state.weightUnit === 'kg') valid = state.weight_kg && state.weight_kg >= 30 && state.weight_kg <= 200;
          else valid = state.weight_lb && state.weight_lb >= 66 && state.weight_lb <= 440;
        } else if (state.step === 'usual') valid = !!state.usual;
        else if (state.step === 'fit') valid = !!state.fit;
        nextBtn.disabled = !valid;
      }

      function compute() {
        var h = state.heightUnit === 'cm' ? Number(state.height_cm)
              : (Number(state.height_ft || 0) * 30.48 + Number(state.height_in || 0) * 2.54);
        var w = state.weightUnit === 'kg' ? Number(state.weight_kg)
              : Number(state.weight_lb || 0) * 0.4536;

        var sizes = chart.sizes;
        var fitBias = chart.fit_bias || 'regular';

        var scored = sizes.map(function (s, i) {
          var score = 0;
          if (s.height_range && s.height_range.length === 2) {
            if (h >= s.height_range[0] && h <= s.height_range[1]) score += 40;
            else {
              var hDist = h < s.height_range[0] ? s.height_range[0] - h : h - s.height_range[1];
              score -= Math.min(35, hDist * 1.6);
            }
          }
          if (s.weight_range && s.weight_range.length === 2) {
            if (w >= s.weight_range[0] && w <= s.weight_range[1]) score += 40;
            else {
              var wDist = w < s.weight_range[0] ? s.weight_range[0] - w : w - s.weight_range[1];
              score -= Math.min(35, wDist * 1.6);
            }
          }
          if (state.usual && state.usual !== 'unknown') {
            if (s.name.toUpperCase() === state.usual.toUpperCase()) score += 12;
            else {
              var idxU = -1;
              sizes.forEach(function (x, xi) { if (x.name.toUpperCase() === state.usual.toUpperCase()) idxU = xi; });
              if (idxU >= 0) {
                var diff = Math.abs(idxU - i);
                if (diff === 1) score += 6;
              }
            }
          }
          return { name: s.name, index: i, score: score };
        }).sort(function (a, b) { return b.score - a.score; });

        var baseIdx = scored[0].index;
        var adjusted = baseIdx;
        if (state.fit === 'slim' && fitBias !== 'slim' && baseIdx > 0) adjusted = baseIdx - 1;
        else if (state.fit === 'oversized' && fitBias !== 'oversized' && baseIdx < sizes.length - 1) adjusted = baseIdx + 1;
        else if (state.fit === 'boxy') adjusted = Math.min(sizes.length - 1, baseIdx + (fitBias === 'oversized' ? 1 : 2));

        var finalSize = sizes[adjusted].name;
        state.result = finalSize;

        var hLabel = Math.round(h) + ' cm';
        var wLabel = Math.round(w) + ' kg';
        var fitLabel = { slim: 'slim', regular: 'regular', oversized: 'oversized', boxy: 'boxy' }[state.fit] || state.fit;
        var reasoning = 'For ' + hLabel + ' and ' + wLabel + ', with a ' + fitLabel + ' fit preference';
        if (state.usual && state.usual !== 'unknown') reasoning += ' (you usually wear ' + state.usual.toUpperCase() + ')';
        reasoning += ', ' + finalSize + ' is your best match for ' + productTitle + '.';

        root.querySelector('[data-sa-result-size]').textContent = finalSize;
        root.querySelector('[data-sa-reasoning]').textContent = reasoning;
        root.querySelector('[data-sa-cart-size]').textContent = finalSize;

        /* Populate garment measurements if present in chart */
        var sizeObj = sizes[adjusted];
        var measurementsEl = root.querySelector('[data-sa-measurements]');
        var measurementsList = root.querySelector('[data-sa-measurements-list]');
        if (measurementsEl && measurementsList) {
          var fields = [];
          ['chest', 'length', 'shoulder', 'waist', 'hip', 'sleeve', 'inseam'].forEach(function (key) {
            if (sizeObj[key] != null) fields.push({ label: key, value: sizeObj[key] });
          });
          if (fields.length) {
            measurementsList.innerHTML = '';
            fields.forEach(function (f) {
              var dt = document.createElement('dt'); dt.textContent = f.label;
              var dd = document.createElement('dd'); dd.textContent = f.value + ' cm';
              measurementsList.appendChild(dt); measurementsList.appendChild(dd);
            });
            measurementsEl.hidden = false;
          } else {
            measurementsEl.hidden = true;
          }
        }

        /* Save to localStorage + update the inline badge */
        try {
          localStorage.setItem(savedKey, JSON.stringify({
            recommended: finalSize,
            answers: { height_cm: Math.round(h), weight_kg: Math.round(w), usual: state.usual, fit: state.fit },
            ts: Date.now()
          }));
          savedBadge.textContent = '· ' + finalSize;
          savedBadge.setAttribute('data-has-saved', '');
          savedBadge.hidden = false;
        } catch (e) {}
      }

      /* Add to cart */
      var addBtn = root.querySelector('[data-sa-add-to-cart]');
      addBtn.addEventListener('click', function () {
        if (!state.result || !variants || !variants.length) return;
        var target = state.result.toUpperCase();
        var variant = null;
        variants.forEach(function (v) {
          if (variant) return;
          var opts = v.options || [];
          for (var i = 0; i < opts.length; i++) {
            if (String(opts[i]).toUpperCase() === target) { variant = v; break; }
          }
        });
        if (!variant) {
          addBtn.textContent = 'Size not available for this product';
          addBtn.disabled = true;
          return;
        }
        if (!variant.available) {
          addBtn.textContent = state.result + ' is sold out';
          addBtn.disabled = true;
          return;
        }
        addBtn.disabled = true;
        var originalHTML = addBtn.innerHTML;
        addBtn.textContent = 'Adding...';
        addToCart(variant.id, function () {
          addBtn.textContent = 'Added';
          setTimeout(function () {
            closeModal();
            addBtn.disabled = false;
            addBtn.innerHTML = originalHTML;
          }, 900);
        }, function () {
          addBtn.textContent = 'Something went wrong';
          setTimeout(function () { addBtn.disabled = false; addBtn.innerHTML = originalHTML; }, 1500);
        });
      });

      /* Retake */
      root.querySelector('[data-sa-retake]').addEventListener('click', function () {
        state = {
          step: 'intro',
          heightUnit: 'cm', weightUnit: 'kg',
          height_cm: null, height_ft: null, height_in: null,
          weight_kg: null, weight_lb: null,
          usual: null, fit: null, result: null
        };
        root.querySelectorAll('[data-sa-field]').forEach(function (i) { i.value = ''; });
        root.querySelectorAll('[data-sa-options] button').forEach(function (b) { b.classList.remove('is-selected'); });
        /* Reset unit toggles to default */
        root.querySelectorAll('[data-sa-unit-group]').forEach(function (g) {
          var btns = g.querySelectorAll('button');
          btns.forEach(function (b, i) { b.classList.toggle('is-active', i === 0); });
          var parent = g.parentElement;
          parent.querySelectorAll('[data-sa-unit-view]').forEach(function (v, i) { v.hidden = i !== 0; });
        });
        showStep('intro');
      });

      /* Email lead capture — create Shopify customer tagged for Klaviyo */
      var emailForm = root.querySelector('[data-sa-email-form]');
      if (emailForm) {
        emailForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var emailInput = emailForm.querySelector('input[type="email"]');
          var email = emailInput.value.trim();
          if (!email) return;
          var status = root.querySelector('[data-sa-email-status]');
          var submitBtn = emailForm.querySelector('button');
          submitBtn.disabled = true;
          var origText = submitBtn.textContent;
          submitBtn.textContent = '...';

          var formData = new FormData();
          formData.append('form_type', 'customer');
          formData.append('utf8', '\u2713');
          formData.append('contact[email]', email);
          formData.append('contact[tags]', 'size-advisor, product:' + productHandle + ', size:' + state.result);
          formData.append('contact[accepts_marketing]', 'true');

          fetch('/contact#contact_form', { method: 'POST', body: formData })
            .then(function (r) {
              status.textContent = 'Saved. We will remember your size.';
              status.hidden = false;
              submitBtn.textContent = 'Saved';
              emailInput.disabled = true;
            })
            .catch(function () {
              status.textContent = 'Try again in a moment.';
              status.hidden = false;
              submitBtn.disabled = false;
              submitBtn.textContent = origText;
            });
        });
      }
    }
  };

  var ShrinkHero = {
    init: function () {
      var s = document.querySelector('.eros-shrink-hero'); if (!s) return;
      var f = s.querySelector('.eros-shrink-hero__fixed'), t = s.querySelector('.eros-shrink-hero__text');
      if (!f || !t) return;
      document.body.classList.add('eros-shrink-active');
      var sT = s.offsetTop, sH = s.offsetHeight, vH = window.innerHeight, d = Math.max(sH - vH * 0.3, 200), tk = false;
      function u() {
        var p = Math.max(0, Math.min((window.scrollY - sT) / d, 1));
        if (p >= 1) { s.classList.add('is-complete'); document.body.classList.add('eros-shrink-done'); t.style.transform = ''; t.style.opacity = '0'; return; }
        s.classList.remove('is-complete'); document.body.classList.remove('eros-shrink-done');
        var sc, tx, ty, op;
        if (p <= 0.6) { var p1 = p / 0.6; sc = 1 - p1 * 0.82; tx = 0; ty = 0; op = 1; }
        else { var p2 = (p - 0.6) / 0.4; sc = 0.18 - p2 * 0.06; tx = -p2 * 35; ty = -p2 * 40; op = 1 - p2; }
        t.style.transform = 'translate(' + tx + 'vw,' + ty + 'vh) scale(' + sc + ')';
        t.style.opacity = op;
      }
      window.addEventListener('scroll', function () { if (!tk) { requestAnimationFrame(function () { u(); tk = false; }); tk = true; } }, { passive: true });
      window.addEventListener('resize', function () { sT = s.offsetTop; sH = s.offsetHeight; vH = window.innerHeight; d = Math.max(sH - vH * 0.3, 200); });
      u();
      new IntersectionObserver(function (e) { f.style.display = e[0].isIntersecting ? '' : 'none'; }, { threshold: 0 }).observe(s);
    }
  };

  /* ------------------------------------------------------------ */
  /* GIFT AUTO-ADD — monitors cart total, adds/removes free-gift   */
  /* line item when threshold is crossed. Marks with a line item   */
  /* property so we can identify + remove it cleanly.              */
  /* Merchant still needs to set up a Shopify automatic discount   */
  /* (Buy X get Y → [gift product] 100% off) for the item to be    */
  /* priced $0 at checkout.                                        */
  /* ------------------------------------------------------------ */
  var GiftAutoAdd = {
    inited: false, busy: false, lastEval: 0,
    MIN_INTERVAL_MS: 800,

    init: function () {
      if (this.inited) return;
      this.inited = true;
      var self = this;
      /* Initial evaluation (once DOM ready) */
      setTimeout(function () { self.evaluate(true); }, 400);
      setTimeout(function () { self.evaluate(true); }, 1500);
      /* React to every cart mutation — native Horizon + custom + both remove buttons */
      ['CartUpdateEvent', 'cart:updated', 'cart:refresh',
       'QuantitySelectorUpdateEvent', 'DiscountUpdateEvent'].forEach(function (evt) {
        document.addEventListener(evt, function () {
          /* Force reset busy + evaluate twice (race condition safety) */
          self.busy = false;
          setTimeout(function () { self.evaluate(true); }, 150);
          setTimeout(function () { self.evaluate(true); }, 600);
        });
      });
      /* Catch manual quantity clicks + remove X */
      document.addEventListener('click', function (e) {
        if (e.target.closest('.cart-items__remove, .eros-cart-row__remove, .quantity-selector button, [on\\:click*="onLineItemRemove"]')) {
          self.busy = false;
          setTimeout(function () { self.evaluate(true); }, 400);
          setTimeout(function () { self.evaluate(true); }, 900);
        }
      });
    },

    config: function () {
      var root = document.documentElement;
      var variantId = parseInt(root.getAttribute('data-eros-gift-variant-id') || '0', 10);
      var thresholdCents = parseInt(root.getAttribute('data-eros-gift-threshold-cents') || '0', 10);
      var enabled = root.getAttribute('data-eros-gift-autoadd') === 'true';
      return { variantId: variantId, thresholdCents: thresholdCents, enabled: enabled };
    },

    evaluate: function (force) {
      var self = this;
      var cfg = this.config();
      if (!cfg.enabled || !cfg.variantId || !cfg.thresholdCents) return;
      if (this.busy && !force) return;
      this.busy = true;
      var busyTimeout = setTimeout(function () { self.busy = false; }, 3000);

      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        /* Find gift line marked via _eros_gift=yes */
        var giftIndex = -1;
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.properties && it.properties._eros_gift === 'yes') { giftIndex = i; break; }
        }
        /* Compute effective total excluding gift price (so threshold logic is stable) */
        var giftPrice = giftIndex >= 0 ? (cart.items[giftIndex].final_line_price || 0) : 0;
        var effectiveTotal = (cart.total_price || 0) - giftPrice;
        var shouldHave = effectiveTotal >= cfg.thresholdCents;

        if (shouldHave && giftIndex < 0) {
          return self.addGift(cfg.variantId);
        }
        if (!shouldHave && giftIndex >= 0) {
          return self.removeGift(giftIndex + 1);
        }
      }).catch(function (e) { console.warn('[eros gift] evaluate', e); })
        .then(function () { clearTimeout(busyTimeout); self.busy = false; });
    },

    addGift: function (variantId) {
      var sectionIds = findCartSectionIds();
      var body = {
        items: [{ id: variantId, quantity: 1, properties: { '_eros_gift': 'yes' } }]
      };
      if (sectionIds.length) body.sections = sectionIds.join(',');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (resp) {
        if (resp && resp.sections) rerenderCartRegions(resp.sections);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        refreshCartCounts(cart);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
      });
    },

    removeGift: function (lineIndex) {
      var sectionIds = findCartSectionIds();
      var body = { line: lineIndex, quantity: 0 };
      if (sectionIds.length) body.sections = sectionIds.join(',');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (resp) {
        if (resp && resp.sections) rerenderCartRegions(resp.sections);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        refreshCartCounts(cart);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart, bubbles: true }));
      });
    }
  };

  /* ------------------------------------------------------------ */
  /* CART UPSELLS — cart drawer recommendations fetcher            */
  /* Watches for [data-eros-recs] appearing in DOM (initial render */
  /* or after morphSection), fetches /recommendations.json with    */
  /* fallback to /products.json or a configured collection, then   */
  /* renders rec cards using .eqa-size (the existing AJAX cart).   */
  /* ------------------------------------------------------------ */
  var CartUpsells = {
    done: {}, observed: false,

    init: function () {
      this.scan();
      if (!this.observed) {
        this.observed = true;
        var self = this;
        /* Watch the whole body for new shells appearing (after morphSection
           re-renders, the old shell is replaced by a fresh one). */
        var mo = new MutationObserver(function () { self.scan(); });
        mo.observe(document.body, { childList: true, subtree: true });

        /* Cart update events — reset + re-scan */
        ['CartUpdateEvent', 'cart:updated', 'cart:refresh'].forEach(function (evt) {
          document.addEventListener(evt, function () {
            self.done = {};
            setTimeout(function () { self.scan(); }, 100);
          });
        });

        /* Click on any cart-opening button */
        document.addEventListener('click', function (e) {
          if (e.target.closest('[aria-label*="cart" i]')) {
            setTimeout(function () { self.scan(); }, 120);
          }
        });
      }
    },

    scan: function () {
      var self = this;
      document.querySelectorAll('[data-eros-recs]').forEach(function (shell) {
        var seed = shell.dataset.seedProductId;
        if (!seed) return;
        if (self.done[seed] && shell.querySelector('.eros-cart-rec')) return;
        self.fetchAndRender(shell, seed);
      });
    },

    fetchAndRender: function (shell, seed) {
      var self = this;
      if (shell.dataset.fetching === '1') return;
      shell.dataset.fetching = '1';

      var limit = parseInt(shell.dataset.limit || '4', 10);
      var collectionHandle = shell.dataset.collection || '';
      var track = shell.querySelector('[data-recs-track]');
      if (!track) { shell.dataset.fetching = '0'; return; }

      function fallback() {
        var url = collectionHandle
          ? '/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=30'
          : '/products.json?limit=30';
        return fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          var pool = (data && data.products) || [];
          var seedInt = parseInt(seed, 10);
          pool = pool.filter(function (p) { return p.id !== seedInt; });
          for (var i = pool.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
          }
          return pool.map(self.normalize);
        });
      }

      var primary = '/recommendations.json?product_id=' + encodeURIComponent(seed) +
                    '&limit=' + (limit + 4) + '&intent=complementary';

      fetch(primary)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (products.length) return products.map(self.normalize);
          return fallback();
        })
        .catch(fallback)
        .then(function (products) {
          var inStock = (products || []).filter(function (p) { return p.available !== false; }).slice(0, limit);
          self.render(shell, track, inStock);
          self.done[seed] = true;
        })
        .catch(function (e) { console.warn('[eros-cu] recs fail', e); })
        .then(function () { shell.dataset.fetching = '0'; });
    },

    normalize: function (p) {
      var img = p.featured_image
              || (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '')
              || '';
      if (typeof img === 'object') img = img.src || '';
      var price = 0, cmp = null;
      if (typeof p.price === 'number') {
        price = p.price;
        cmp = p.compare_at_price && p.compare_at_price > p.price ? p.compare_at_price : null;
      } else if (p.variants && p.variants[0]) {
        price = Math.round(parseFloat(p.variants[0].price) * 100);
        if (p.variants[0].compare_at_price) {
          cmp = Math.round(parseFloat(p.variants[0].compare_at_price) * 100);
          if (cmp <= price) cmp = null;
        }
      }
      var available = p.available;
      if (available === undefined) {
        available = (p.variants || []).some(function (v) { return v.available !== false; });
      }
      return {
        id: p.id, title: p.title, handle: p.handle,
        url: p.url || ('/products/' + p.handle),
        price: price, cmp: cmp, available: available, img: img,
        variants: (p.variants || []).map(function (v) {
          return {
            id: v.id,
            label: (v.options && v.options[0]) || v.option1 || v.title || '',
            available: v.available !== false
          };
        })
      };
    },

    render: function (shell, track, products) {
      if (!products.length) { shell.style.display = 'none'; return; }
      shell.style.display = '';
      track.innerHTML = products.map(CartUpsells.cardHTML).join('');
      /* Hand the new <product-card> elements to QuickAdd so it attaches
         the + button (mobile) / hover size bar (desktop) to each. */
      if (typeof QuickAdd !== 'undefined' && QuickAdd.injectAll) {
        setTimeout(function () { QuickAdd.injectAll(); }, 10);
      }
    },

    cardHTML: function (p) {
      /* Emit native <product-card> markup so the existing QuickAdd module
         attaches its + button (mobile) and hover size bar (desktop),
         giving rec cards the same interaction as the rest of the store. */
      var imgUrl = p.img;
      if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
      var curr = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EGP';
      var priceStr = (p.price / 100).toFixed(0) + ' ' + curr;
      /* Compare-at without currency to save space and prevent wrapping */
      var cmpStr = p.cmp ? (p.cmp / 100).toFixed(0) : null;
      var safeTitle = String(p.title || '').replace(/[<>]/g, '');
      var soldOut = !p.available;
      var variantCount = (p.variants || []).length;
      return (
        '<product-card ' +
          'class="product-card eros-cart-rec' + (soldOut ? ' product-card--sold-out' : '') + '" ' +
          'data-product-handle="' + p.handle + '" ' +
          'data-product-id="' + (p.id || '') + '" ' +
          'data-product-variants-size="' + variantCount + '"' +
          (soldOut ? ' data-sold-out="true"' : '') +
        '>' +
          '<a href="' + p.url + '" class="product-card__link" aria-label="' + safeTitle.replace(/"/g, '') + '">' +
            '<span class="visually-hidden">' + safeTitle + '</span>' +
          '</a>' +
          '<div class="product-card__content" style="--quick-add-display: grid;">' +
            '<div class="card-gallery">' +
              (imgUrl ? '<img class="eros-cart-rec__img" src="' + imgUrl + '" alt="" loading="lazy">' : '') +
              (soldOut ? '<div class="eros-soldout-overlay" aria-hidden="true"></div>' : '') +
            '</div>' +
            '<div class="eros-cart-rec__foot">' +
              '<a class="eros-cart-rec__title" href="' + p.url + '">' + safeTitle + '</a>' +
              '<p class="eros-cart-rec__price"><span>' + priceStr + '</span>' +
                (cmpStr ? '<s>' + cmpStr + '</s>' : '') +
              '</p>' +
            '</div>' +
          '</div>' +
        '</product-card>'
      );
    }
  };
  function initAll() {
    ViewToggle.init();
    QuickAdd.init();
    ShrinkHero.init();
    setupCurtainReveal();
    BigLogo.init();
    ParallaxWorlds.init();
    ScrollStack.init();
    StickyHero.init();
    SizeAdvisor.init();
    CartUpsells.init();
    GiftAutoAdd.init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  ['shopify:section:load','shopify:section:unload','shopify:section:reorder','shopify:section:select','shopify:block:select','shopify:block:deselect']
    .forEach(function (evt) { document.addEventListener(evt, initAll); });

})();
